import { Box, Text } from '@wix/design-system';
import { CycleId, CycleUtils } from '@wix/package-picker-shared';
import React from 'react';
import { EclipsePackagePickerModule } from '../../modules/eclipse-package-picker.module';
import s from './BrazilCyclePrice.scss';

export const BrazilCyclePrice = ({
  productId,
  cycleId,
}: {
  productId: string;
  cycleId: CycleId;
}) => {
  const { t } = EclipsePackagePickerModule.internals.useTranslations();

  const { data: product } =
    EclipsePackagePickerModule.SDK.eclipseOfferingApiClient.hooks.useFetchProduct(
      { productId },
      Boolean(productId),
    );

  const { hasSale, pricingDetails } = product ?? {};

  const pricingDetail = pricingDetails?.find(
    (d) => d.cycle && CycleUtils.convertCycleToCycleId(d.cycle) === cycleId,
  );

  const cycle = pricingDetail?.cycle;
  const catalogPeriodPrice = pricingDetail?.initialPurchasePrice?.subtotal;
  const periodPrice = pricingDetail?.finalPrice?.subtotal;
  const monthlyFinalPrice = pricingDetail?.finalPrice?.monthlyTotal;

  const cycleLength = cycle
    ? CycleUtils.convertCycleDurationToMonths(cycle)
    : 0;

  return (
    <Box direction="vertical">
      <Box direction="horizontal" verticalAlign="middle" gap="SP1">
        {hasSale &&
          catalogPeriodPrice?.formattedAmount &&
          catalogPeriodPrice.formattedAmount !==
            periodPrice?.formattedAmount && (
            <Text skin="disabled" className={s.strikethrough}>
              {catalogPeriodPrice.formattedAmount}
            </Text>
          )}
        {periodPrice?.formattedAmount && (
          <Text>
            {t('cycle_entry.cycle_price.in_cash', {
              fullPrice: periodPrice.formattedAmount,
            })}
          </Text>
        )}
      </Box>
      {monthlyFinalPrice?.formattedAmount && (
        <Text>
          {t('cycle_entry.cycle_price.br', {
            price: monthlyFinalPrice.formattedAmount,
            cycleLength,
          })}
        </Text>
      )}
    </Box>
  );
};
